import React, { useMemo ,useEffect} from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FiMinus, FiPlus } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import cartimg from "../images/Frame 1321316343.png";
import deleteimg from "../images/Delete.png";
import { MediaQueries } from "../components/utils";
import Paymentdetails from "../components/Common/Paymentdetails";
import Breadcomp from "../components/Common/Breadcomp";
import editimg from "../images/Edit.png";
import Addresslist from "../components/Common/Addresslist"
import { getalladdresses } from "../redux/addresslice";
import {pushToDataLayer} from "../components/utils/dataUserpush"
const Address = () => {
    const dispatch = useDispatch();
    //    dispatch(getalladdressesapi(0));
    const { isMobile } = MediaQueries();
    const addresslistdata = useSelector(state => state.addresslice.addresslistdata);
       const cartlistdata = useSelector((state) => state.cartslice.cartlistdata);
        const currentcountry = useSelector((state) => state.globalslice.currentcountry);
        useEffect(() => {
                   pushToDataLayer("viewed_address_page",currentcountry.name);
                 }, []);
    return (
        <div className="mobile-marginbottom" >
            <Container fluid className="homepagecontainer">
            <div className={`${isMobile ? 'pt-1 pb-1' : 'pt-3 pb-3'}`}>
                    <Breadcomp />
                </div>

                <div className="Cart-titile">Select Delivery address</div>
                <Row>
                    <Col lg={8}>
                    <Addresslist/>
                       

                    </Col>
                    <Col lg={4}>
                        <div className="pricedetails">
                            <Paymentdetails />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};


export default Address;